var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--partner-with-us_airalo-partner-hub_looking-for-more-custom"
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('div', {
    staticClass: "looking-for-more-custom"
  }, [_c('div', {
    staticClass: "looking-for-more-custom-texts"
  }, [_c('h2', {
    staticClass: "looking-for-more-custom-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('components.looking.for.more.custom.title')) + "\n        ")]), _vm._v(" "), _c('i18n', {
    staticClass: "looking-for-more-custom-subtitle",
    attrs: {
      "path": "components.looking.for.more.custom.subtitle",
      "tag": "p"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "call-to-action light tw-w-auto tw-mt-5 tw-py-4 tw-px-5 tw-flex tw-justify-center tw-items-center hover:tw-no-underline",
    attrs: {
      "target": "_blank",
      "href": "https://app.partners.airalo.com/onboarding/contact-us"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('components.looking.for.more.custom.cta-button')) + "\n      ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }